var _rect, _rect2, _rect3, _g, _rect4, _g2, _rect5, _g3, _rect6, _g4, _rect7, _rect8, _rect9, _path, _tspan, _tspan2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataAttribute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465.02,
    height: 230.8,
    viewBox: "0 0 123.04 61.066",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.4979 -4.4979)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2491 0 0 1.1553 -109.35 1.9102)",
    strokeWidth: 0.27554
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91.602,
    y: 2.7168,
    width: 97.582,
    height: 51.902,
    rx: 0.84729,
    ry: 0.91605,
    fill: "#528dff",
    fillOpacity: 0.05098,
    stroke: "#0057ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeOpacity: 0.65882,
    strokeWidth: 0.49589
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 24.561,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    fill: "#808080",
    fillOpacity: 0.33,
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.93,
    y: 24.561,
    width: 20.451,
    height: 3.7904,
    rx: 0.63547,
    ry: 0.68704,
    fill: "#fff",
    fillOpacity: 0.1,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.72,
    y: 24.087,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.476,
    y: 23.779,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 31.061,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    opacity: 0.8
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141.93,
    y: 31.061,
    width: 20.451,
    height: 3.7904,
    rx: 0.63547,
    ry: 0.68704,
    fill: "#fff",
    fillOpacity: 0.1,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.72,
    y: 30.587,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.476,
    y: 30.279,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 37.273,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141.93,
    y: 37.273,
    width: 20.451,
    height: 3.7904,
    rx: 0.63547,
    ry: 0.68704,
    fill: "#fff",
    fillOpacity: 0.1,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.72,
    y: 36.799,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.476,
    y: 36.492,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 43.37,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    opacity: 0.4
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 141.93,
    y: 43.37,
    width: 20.451,
    height: 3.7904,
    rx: 0.63547,
    ry: 0.68704,
    fill: "#fff",
    fillOpacity: 0.1,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#808080",
    fillOpacity: 0.33
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.72,
    y: 42.897,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.476,
    y: 42.589,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.1,
    y: 49.354,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3741,
    opacity: 0.9
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141.93,
    y: 49.354,
    width: 20.451,
    height: 3.7904,
    rx: 0.63547,
    ry: 0.68704,
    fill: "#fff",
    fillOpacity: 0.1,
    stroke: "#0058ff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.23045
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.72,
    y: 48.88,
    width: 20.451,
    height: 3.7904,
    rx: 1.151,
    ry: 1.14,
    fill: "#808080",
    fillOpacity: 0.33,
    opacity: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 93.476,
    y: 48.572,
    width: 20.451,
    height: 3.7904,
    rx: 1.2709,
    ry: 1.3609,
    fill: "#808080",
    fillOpacity: 0.33,
    opacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0058ff"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m94.457 13.198c-0.19422-0.03895-0.35011-0.19146-0.40933-0.40046-0.01966-0.06936-0.02625-0.17156-0.01541-0.23882 0.01865-0.11581 0.1842-0.70616 0.34363-1.2255 0.02543-0.08282 0.0583-0.14343 0.11166-0.20573 0.08277-0.09666 0.12658-0.12124 0.55393-0.31074 0.14115-0.06259 0.31357-0.13948 0.38318-0.17084 0.20312-0.09152 0.44857-0.19263 0.70812-0.29166l0.08625-0.03289 0.0188 0.07032c0.08263 0.30907 0.57385 1.8688 0.59726 1.8963 0.0035 0.0043 0.0061-0.0054 0.0061-0.02311-6.7e-5 -0.01673 0.01304-0.33617 0.02913-0.70985l0.02922-0.67941-0.12141-0.26056c-0.04896-0.08792-0.15008-0.23607-0.13016-0.25381 0.01229-0.01098 0.03445 0.01027 0.06676 0.02819 0.13748 0.0744 0.29386 0.14292 0.48651 0.151 0.21141 0.0088 0.38199-0.06265 0.56071-0.15018 0.0366-0.01853 0.07603-0.05061 0.09089-0.03247 0.02001 0.02441-0.14369 0.2455-0.14614 0.25077l-0.12441 0.26609 0.03025 0.7086c0.01665 0.38972 0.03246 0.70609 0.03516 0.70301 0.01766-0.0202 0.52532-1.6344 0.59955-1.9064l0.01608-0.05888 0.23879 0.09437c0.28106 0.11106 0.3102 0.12324 0.56477 0.23575 0.8077 0.35689 0.81669 0.36141 0.90536 0.4529 0.04523 0.04664 0.097 0.12527 0.11509 0.17476 6e-3 0.01695 0.0337 0.10635 0.0613 0.19862 0.1816 0.60936 0.28587 0.98662 0.30007 1.0856 0.0266 0.18547-0.0505 0.39571-0.18972 0.51751-0.0483 0.0423-0.13614 0.09131-0.1994 0.1114-0.0405 0.01283-0.19099 0.01361-2.7978 0.01483-2.2327 1e-3 -2.7644-6.29e-4 -2.8049-0.0087zm2.687-3.1519c-0.32974-0.07761-0.64781-0.31234-0.87954-0.649-0.12377-0.17987-0.24845-0.44557-0.31475-0.67073-0.01569-0.05322-0.01716-0.055417-0.03464-0.050212-0.03332 0.010028-0.08929 0.00418-0.11899-0.012153-0.1129-0.062269-0.19077-0.26042-0.22761-0.57921-0.0225-0.19453-0.0061-0.29264 0.05953-0.35502 0.0416-0.039599 0.08635-0.053614 0.17109-0.053614h0.06719l-5e-3 -0.12523c-0.01766-0.44242-0.01592-0.55381 0.01082-0.70278 0.11238-0.62664 0.59099-1.1049 1.1802-1.1794 0.4232-0.053507 0.8008 0.065791 1.1136 0.35191 0.20485 0.18736 0.36992 0.48753 0.43149 0.78472 0.032 0.15444 0.03681 0.24913 0.02713 0.53535-0.0047 0.14003-0.0086 0.2728-0.0085 0.29502l1.54e-4 0.040458h0.06691c0.11035 0 0.16724 0.029225 0.20572 0.10566 0.0377 0.074888 0.03996 0.17948 0.0085 0.39525-0.04877 0.3344-0.1681 0.52789-0.31123 0.50468-0.01674-0.00275-0.03334-0.00489-0.03687-0.00478-0.0035 9.43e-5 -0.01825 0.037641-0.0327 0.083436-0.14635 0.46392-0.39735 0.83663-0.72 1.069-0.08298 0.059774-0.22359 0.136-0.31363 0.17008-0.14663 0.055453-0.24421 0.068883-0.33882 0.046618z",
    strokeWidth: 0.008059
  })), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.96174 1.0398)",
    x: 105.54952,
    y: 12.606792,
    fontFamily: "Jamrul",
    fontSize: "7.4885px",
    strokeDasharray: "0.303777, 0.607555, 0.303777, 1.21511",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.30378,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 105.54952,
    y: 12.606792,
    fill: "#0058ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "7.4885px",
    strokeWidth: 0.30378
  }, "Contact"))), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.96174 1.0398)",
    x: 147.77205,
    y: 20.409595,
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8455px",
    strokeMiterlimit: 10,
    strokeOpacity: 0.33,
    strokeWidth: 0.066075,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 147.77205,
    y: 20.409595,
    fill: "#0058ff",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8455px",
    strokeWidth: 0.066075
  }, "Address"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m143.05 27.357c0 0.04431 0.0251 0.05511 0.0568 0.05511h0.30877c0.0317 0 0.0581-0.01081 0.0581-0.05511 0-0.04432-0.0252-0.05561-0.057-0.05561h-0.0969l-1e-3 -1.7045h0.0969c0.0317 0 0.0566-0.0022 0.0566-0.04648 0-0.04434-0.0248-0.05032-0.0566-0.05032h-0.30877c-0.0317 0-0.0583 6e-3 -0.0583 0.05028 0 0.04432 0.0265 0.04648 0.0583 0.04648h0.097l1e-3 1.7045h-0.097c-0.0317 0-0.0579 0.01131-0.0579 0.05565z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAttribute);
export default __webpack_public_path__ + "static/media/data-attribute.2e8998cf455df76147466273f559bfee.svg";
export { ForwardRef as ReactComponent };